import React, { useRef, useState, useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import * as actions from '~data/actions/bookmarks'

import { Confirm } from '~co/overlay/dialog'
import { Button, Menu, MenuItem, MenuSeparator, Popover, Icon } from '~ui'

export default function BookmarksSelectModeMore({ spaceId, selectMode = {} }) {
    const dispatch = useDispatch()
    const pin = useRef(null)
    const [menu, setMenu] = useState(false)
    const { all, ids = [] } = selectMode

    const onContextMenuClick = useCallback(() => setMenu(true), [])
    const onContextMenuClose = useCallback(() => setMenu(false), [])

    const onImportantClick = useCallback(
        e => {
            e.preventDefault()
            dispatch(actions.importantSelected(spaceId, true))
        },
        [dispatch, spaceId]
    )

    const onImportantRemoveClick = useCallback(
        e => {
            e.preventDefault()
            dispatch(actions.importantSelected(spaceId, false))
        },
        [dispatch, spaceId]
    )

    const onScreenshotClick = useCallback(
        e => {
            e.preventDefault()
            dispatch(actions.screenshotSelected(spaceId))
        },
        [dispatch, spaceId]
    )

    const onRemoveTagsClick = useCallback(
        e => {
            e.preventDefault()
            const title = t.s('removeAllTags')
            Confirm(title, {
                description: t.s('areYouSure'),
                ok: title,
                variant: 'warning'
            }).then(yes => {
                if (yes)
                    dispatch(actions.removeTagsSelected(spaceId))
            })
        },
        [dispatch, spaceId]
    )

    const onReparseClick = useCallback(
        e => {
            e.preventDefault()
            dispatch(actions.reparseSelected(spaceId))
        },
        [dispatch, spaceId]
    )

    return (
        <>
            <Button
                ref={pin}
                variant='outline'
                disabled={!all && !ids.length}
                onClick={onContextMenuClick}>
                <Icon name='more_horizontal' />
            </Button>

            {menu ? (
                <Popover pin={pin} onClose={onContextMenuClose}>
                    <Menu>
                        <MenuItem onClick={onScreenshotClick}>
                            <Icon name='web' />
                            {t.s('clickToMakeScreenshot')}
                        </MenuItem>

                        <MenuItem onClick={onReparseClick}>
                            <Icon name='refresh' />
                            {t.s('refreshPreview')}
                        </MenuItem>

                        <MenuSeparator />

                        <MenuItem onClick={onImportantClick}>
                            <Icon name='like_active' />
                            {t.s('addToFavorites')}
                        </MenuItem>

                        <MenuItem onClick={onImportantRemoveClick}>
                            <Icon name='like' />
                            {t.s('removeFromFavorites')}
                        </MenuItem>

                        <MenuSeparator />

                        <MenuItem onClick={onRemoveTagsClick}>
                            <Icon name='tag' />
                            {t.s('removeTags')}
                        </MenuItem>
                    </Menu>
                </Popover>
            ) : null}
        </>
    )
}
